import { useMemo } from 'react'
import { usePlatformConfig } from '@dxp-module/common'
import ROUTES from '../enum/Routes'
import { TargetTypes } from '../../LoginOrSignup/enum/TargetTypes'
import {
  useGetDealQuery,
  JourneyType,
} from '../graphql/__generated__/graphql.autogenerated'
import useUrlSearchParams from './useUrlSearchParams'

const useRedirectRoute = () => {
  const {
    platformConfig: {
      myAccount: { accordionListMenu },
    },
  } = usePlatformConfig()

  const { target, token } = useUrlSearchParams() || {}
  const { data } = useGetDealQuery({
    variables: {
      token: token || '',
    },
    skip: !token,
  })

  const journeyType = data?.deal.journeyType

  const availableRoutes: Partial<{ [key in keyof typeof ROUTES]: boolean }> =
    useMemo(() => {
      const keys = Object.keys(ROUTES)

      return keys.reduce(
        (prev, next) => ({
          ...prev,
          [next]: accordionListMenu.some(
            accordionItem =>
              accordionItem.route === next ||
              accordionItem.detailsLinks?.some(item => item.route === next)
          ),
        }),
        {}
      )
    }, [accordionListMenu])

  const redirectRoute = useMemo(() => {
    if (target === TargetTypes.FINANCE) {
      return ROUTES.MYACCOUNT_FINANCE_REDIRECTION
    }

    if (target === TargetTypes.INSURANCE) {
      return ROUTES.MYACCOUNT_INSURANCE
    }

    if (
      journeyType === JourneyType.OnlineOrder &&
      availableRoutes.MYACCOUNT_ORDERS
    ) {
      return ROUTES.MYACCOUNT_ORDERS
    }

    if (
      journeyType === JourneyType.ContinueInDealership &&
      availableRoutes.MYACCOUNT_ENQUIRY
    ) {
      return ROUTES.MYACCOUNT_ENQUIRY
    }

    if (
      journeyType === JourneyType.ReserveOnline &&
      availableRoutes.MYACCOUNT_RESERVATIONS
    ) {
      return ROUTES.MYACCOUNT_RESERVATIONS
    }

    if (
      journeyType === JourneyType.SaveMyBuild &&
      availableRoutes.MYACCOUNT_SAVED_CARS
    ) {
      return ROUTES.MYACCOUNT_SAVED_CARS
    }

    if (availableRoutes.MYACCOUNT_ORDERS) {
      return ROUTES.MYACCOUNT_ORDERS
    }

    if (availableRoutes.MYACCOUNT_RESERVATIONS) {
      return ROUTES.MYACCOUNT_RESERVATIONS
    }

    if (availableRoutes.MYACCOUNT_ENQUIRY) {
      return ROUTES.MYACCOUNT_ENQUIRY
    }

    if (availableRoutes.MYACCOUNT_SAVED_CARS) {
      return ROUTES.MYACCOUNT_SAVED_CARS
    }

    return ROUTES.MYACCOUNT_ORDERS
  }, [availableRoutes, target, journeyType])

  return { redirectRoute }
}

export default useRedirectRoute
